import React, { useState } from 'react';
import { useEffect } from 'react';
import './css/App.css';
import Produto from './Produto'

function App() {
  const url_api = 'https://veiculos.autotruckrecuperadora.com.br'
  const url_detalhes = 'http://localhost/vendas_autotruck/app/detalhes'

  const [produtos, setProdutos] = useState([])

  useEffect(async () => {
    const response = await fetch(url_api + '/gee/produto/getprodutos')
    setProdutos(await response.json())
  }, [])

  return (
    <div className='produtos-container'>
      {produtos.map((item, index) => {
        return (
          <Produto key={index} produto={item} url_detalhes={url_detalhes} url_api={url_api} />
        )
      })}
    </div>
  );
}

export default App;
